import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import NotFound from "./pages/not-found";
import OnlineDeliveryPage from "./pages/online-order/online-order.page";
import OnlineOrderCheckoutPage from "./pages/online-order/online-order-checkout.page";
import AdhocMobilePaymentsPage from "./pages/payments/adhoc.mobile.payments.page";
import MobilePaymentsPage from "./pages/payments/mobilepayment.page";
import ScanToOrderPage from "./pages/scan-to-order/scan-to-order.page";
import AuthProvider from "./providers/auth.provider";
import StoreStatusPage from "./pages/store-status";
import Reservations from "./pages/reservations/reservations";
import HotelReservationsPage from "./pages/hms/hotel-reservations/hotel-reservations.page";
import StoreProvider from "./providers/store.provider";
import CartProvider from "./providers/cart.provider";
import AppointmentsPage from "./pages/appointments/appointments.page";

const App = () => {
  const storesRoutes = (
    <StoreProvider>
      <CartProvider>
        <Routes>
          <Route path="/mobilepayments" element={<AdhocMobilePaymentsPage />} />
          <Route path="/mobilepayments/:pid" element={<MobilePaymentsPage />} />
          <Route path="/scan-to-order" element={<ScanToOrderPage />} />
          <Route path="/reservations" element={<Reservations />} />
          <Route path="/appointments" element={<AppointmentsPage />} />

          <Route path="/online" element={<OnlineDeliveryPage />} />
          <Route
            path="/online/checkout"
            element={<OnlineOrderCheckoutPage />}
          />
          <Route path="/bookings" element={<HotelReservationsPage />} />
          <Route path="/status" element={<StoreStatusPage />} />
        </Routes>
      </CartProvider>
    </StoreProvider>
  );

  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/stores/:id/*" element={storesRoutes} />

          <Route path="/not-found" element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
};
export default App;
